<template>
  <van-uploader
    v-model="fileList"
    :after-read="afterRead"
    :max-count="maxCount"
    :max-size="maxSize"
    multiple
    name="FormFile"
    @oversize="onOversize"
  />
</template>
<script>
  import { onMounted, reactive, ref, toRefs, watch } from 'vue'
  import axios from 'axios'
  import store from '@/store'
  import api from '@/api'
  import { Notify, Toast, Uploader } from 'vant'
  import { getCompressImage } from '@/utils'
  export default {
    props: {
      file: {
        type: String,
        default: '',
      },
      maxCount: {
        type: Number,
        default: 9,
      },
      maxSize: {
        type: Number,
        default: 10 * 1024 * 1024,
      },
      // 压缩至M图片
      limitSize: {
        type: Number,
        default: 500 * 1024 * 1024,
      },
    },
    setup(props, ctx) {
      const fileList = ref([])
      const { file } = toRefs(props)
      const init = ref(false)

      const fileInit = (val) => {
        if (val) {
          const arr = []
          val.split(',').forEach((item) => {
            arr.push({
              url: api.FileHost + item,
              status: 'success',
              isImage: true,
              backUrl: item,
            })
          })
          fileList.value = arr
        }
      }

      watch(file, (newVal) => {
        fileInit(newVal)
      })

      const afterRead = (file) => {
        if (Array.isArray(file)) {
          file.forEach((item) => {
            upload(item)
          })
        } else {
          upload(file)
        }
      }

      const onOversize = (file) => {
        const size = props.maxSize / (1024 * 1024)
        Notify({ type: 'danger', message: `文件大小超过最大${size}M限制` })
      }

      const callback = () => {
        const list = []
        let allUploadDone = true
        fileList.value.forEach((item) => {
          if (item.status != 'success') {
            allUploadDone = false
          }
          list.push(item.backUrl)
        })
        // 当存在同时上传多个文件时 等待全部上传完
        if (allUploadDone) {
          ctx.emit('update:file', list.join(','))
        }
      }

      const upload = async (file) => {
        file.status = 'uploading'
        file.message = '上传中...'
        const blob = await compressImage(file.file)
        const param = new FormData()
        param.append('formFile', blob, file.file.name)
        const token = store.getters['user/token']
        axios({
          method: 'POST',
          url: api.UploadImage,
          data: param,
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'multipart/form-data',
          },
        })
          .then(({ data }) => {
            if (data.Code === 0) {
              file.backUrl = data.Data
              file.status = 'success'
              file.message = '上传成功'
              callback()
            } else {
              file.status = 'failed'
              file.message = '上传失败'
              Notify({ type: 'danger', message: data.Message })
            }
          })
          .catch((e) => {
            file.status = 'failed'
            file.message = '上传失败'
            Notify({ type: 'danger', message: '上传失败' + e.Message })
          })
      }

      /**
       * 压缩
       * @author hanson.liu
       * @date 2021-09-23
       * @param {any} file
       * @returns {any} Promise 小于2M的图片
       */
      const compressImage = (file) => {
        return new Promise((resolve, reject) => {
          console.log(file.size, props.limitSize)
          // 小于limitSize直接上传
          if (file.size < props.limitSize) {
            resolve(file)
            return
          }
          let image = new Image()
          let resultBlob = ''
          image.src = URL.createObjectURL(file)
          image.onload = () => {
            // 调用方法获取blob格式，方法写在下边
            resultBlob = compressUpload(image, file, props.limitSize)
            resolve(resultBlob)
          }
          image.onerror = () => {
            reject()
          }
        })
      }

      /* 图片压缩v2方法-canvas压缩 */
      const compressUpload = (image, file, limitSize, targetWidth = 750) => {
        let canvas = document.createElement('canvas')
        let ctx = canvas.getContext('2d')
        //let initSize = image.src.length
        let { width } = image,
          { height } = image
        canvas.width = targetWidth
        canvas.height = (targetWidth * height) / width
        ctx.fillRect(0, 0, canvas.width, canvas.height)
        ctx.drawImage(image, 0, 0, canvas.width, canvas.height)
        const quality = limitSize / file.size / (targetWidth / width)
        //console.log('压缩质量' + quality * 100)
        let compressData = canvas.toDataURL(file.type || 'image/jpeg', quality)

        // 压缩后调用方法进行base64转Blob，方法写在下边
        let blobImg = dataURItoBlob(compressData)
        return blobImg
      }

      /* base64转Blob对象 */
      const dataURItoBlob = (data) => {
        let byteString
        if (data.split(',')[0].indexOf('base64') >= 0) {
          byteString = atob(data.split(',')[1])
        } else {
          byteString = unescape(data.split(',')[1])
        }
        let mimeString = data.split(',')[0].split(':')[1].split(';')[0]
        let ia = new Uint8Array(byteString.length)
        for (let i = 0; i < byteString.length; i += 1) {
          ia[i] = byteString.charCodeAt(i)
        }
        return new Blob([ia], { type: mimeString })
      }

      return {
        fileList,
        afterRead,
        onOversize,
      }
    },
  }
</script>
